import { render, staticRenderFns } from "./WrapperPaymentLink.vue?vue&type=template&id=6b8b0bf0&scoped=true"
import script from "./WrapperPaymentLink.vue?vue&type=script&lang=js"
export * from "./WrapperPaymentLink.vue?vue&type=script&lang=js"
import style0 from "./WrapperPaymentLink.vue?vue&type=style&index=0&id=6b8b0bf0&prod&lang=scss&scoped=true"
import style1 from "./WrapperPaymentLink.vue?vue&type=style&index=1&id=6b8b0bf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b0bf0",
  null
  
)

export default component.exports